import React, { useCallback, useState } from "react";
import { useIntl } from "react-intl";
import { formatCarReceipt } from "../../../utils/format";

const DownloadCar = ({ updateCar }) => {
  const { formatMessage } = useIntl();
  const [value, setValue] = useState("");

  const handleSearchChange = useCallback(e => {
    const formatted = formatCarReceipt(e.target.value);
    setValue(formatted);
    updateCar(formatted);
  }, [updateCar]);


  return (
    <>
      <div
        id="tile is-6 is-vertical input-info input-has-label"
      >
        <>
          <label className="label">
            {formatMessage({ id: "recibo-car" })}
          </label>
          <input
            className="input"
            type="text"
            name="car-name"
            id="car-name"
            size={30}
            value={value}
            onChange={handleSearchChange}
          />
        </>
      </div>
    </>
  );
};

export default DownloadCar;
